export default {
  meta: {
    title: '加盟意向-新建跟进',
    url: '/join/editfollow', // 埋点字段，上报归属的模块
    urlName: '加盟意向-新建跟进' // 埋点字段，上报归属的模块
  }
};
